import { render, staticRenderFns } from "./base-message-server-error.vue?vue&type=template&id=8d2c65d2&scoped=true"
import script from "./base-message-server-error.vue?vue&type=script&lang=js"
export * from "./base-message-server-error.vue?vue&type=script&lang=js"
import style0 from "./base-message-server-error.vue?vue&type=style&index=0&id=8d2c65d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2c65d2",
  null
  
)

export default component.exports